import React from "react";

export default function Hero({ children }) {
  return (
    <>
      <div class="hero">{children}</div>
    </>
  );
}
